import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { FilterValue } from '../../models/ice-database.model';

@Component({
    selector: 'app-filter-options',
    templateUrl: './filter-options.component.html',
    styleUrls: ['./filter-options.component.scss'],
})
export class FilterOptionsComponent {
    @Input() optionList: FilterValue[];
    @Input() selectedValues: FilterValue[];
    @Output() selectedOptions = new EventEmitter<FilterValue[]>();
    @Output() cancelOptions = new EventEmitter<boolean>();
    @Input() totalData: number = 0;
    isFirstLoad: boolean = true;
    constructor(private eRef: ElementRef) {}

    // 👇 Detect click anywhere in the document
    @HostListener('document:click', ['$event'])
    onClickOutside(event: Event) {
        if (!this.eRef.nativeElement.contains(event.target) && !this.isFirstLoad) {
            this.cancelOptions.emit(true); // notify parent to close popup
        }
        this.isFirstLoad = false;
    }

    selectAllChecked = false;

    toggleSelection(option: FilterValue) {
        const index = this.selectedValues.findIndex((opt) => opt.id === option.id);
        if (index > -1) {
            this.selectedValues.splice(index, 1);
        } else {
            this.selectedValues.push(option);
        }
        this.selectAllChecked = this.optionList.every((opt) => this.isSelected(opt));
    }

    selectAll(event: any) {
        this.selectAllChecked = event.checked;
        if (event.checked) {
            this.selectedValues = [...this.optionList];
        } else {
            this.selectedValues = [];
        }
    }

    isSelected(option: FilterValue): boolean {
        this.selectAllChecked = this.selectedValues.length === this.optionList.length;
        return this.selectedValues.some((selectedOption) => selectedOption.id === option.id);
    }

    applyClick() {
        this.selectedOptions.emit(this.selectedValues);
    }

    cancelClick() {
        this.cancelOptions.emit(true);
    }
}
